export {
  type DetectedPackageManager,
  getBinCommand,
  getRunningPackageManager,
  getYarnMajorVersion,
} from '../util/packageManager.js'
